import { Injectable } from '@angular/core';

// CDK
import { MatSnackBar } from '@angular/material/snack-bar';

// RxJs
import { of, switchMap } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';

// NgRX
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { WarrantyRecoveryEffectsActions } from '../actions/warranty.actions';
import { MaintainerUsersEffectsActions } from '@core/store/actions/maintainer.actions';

// Services
import { WarrantyService } from '@core/providers/services/warranty/warranty.service';

// Components
import { SnackBarComponent } from '@views/global/snackbar/snack-bar.component';



@Injectable()
export class WarrantyEffects {


  fillOutContractsTableSelectors$ = createEffect(() => this.actions$.pipe(
    ofType(WarrantyRecoveryEffectsActions.fillOutContractsTableSelectors),
    mergeMap(() => this.warrantyService.fillOutContractsTableSelectors().pipe(
      map(selectors => WarrantyRecoveryEffectsActions.injectContractsTableSelectors({ selectors })),
      catchError(error => {
        this.showSnackBarError('No se pudieron cargar los datos para los selectores de la tabla informativa');
        return of(MaintainerUsersEffectsActions.injectError({ error }));
      })
    )))
  );


  getContracts$ = createEffect(() => this.actions$.pipe(
    ofType(WarrantyRecoveryEffectsActions.getContracts),
    mergeMap(({ page, search, store, criticality }) => this.warrantyService.getContracts(page, search, store, criticality).pipe(
      map(({ body: { content: contracts, total }}) => WarrantyRecoveryEffectsActions.injectContracts({ contracts, total })),
      catchError(({ error }) => of(WarrantyRecoveryEffectsActions.injectError({ error })))
    )))
  );


  exportContractsToExcel$ = createEffect(() => this.actions$.pipe(
    ofType(WarrantyRecoveryEffectsActions.exportContractsToExcel),
    // switchMap(({ store }) => this.warrantyService.generateCsrfToken().pipe(map(() => store))),
    switchMap(({ store }) => this.warrantyService.exportContractsToExcel(store).pipe(
      map(() => WarrantyRecoveryEffectsActions.contractsSuccessfullyExported()),
    )), catchError(() => of(WarrantyRecoveryEffectsActions.contractsFailedExport()))
  ));


  getAutoPayCases$ = createEffect(() => this.actions$.pipe(
    ofType(WarrantyRecoveryEffectsActions.getAutoPayCases),
    mergeMap(() => this.warrantyService.getAutoPayCases().pipe(
      map(autoPayCases => WarrantyRecoveryEffectsActions.injectAutoPayCases({ autoPayCases })),
      catchError(error => {
        this.showSnackBarError('No se pudieron cargar la simbología de casos');
        return of(WarrantyRecoveryEffectsActions.injectError({ error }));
      })
    ))
  ));


  constructor(
    private warrantyService: WarrantyService,
    private readonly snackBar: MatSnackBar,
    private readonly actions$: Actions,
  ) { }


  private showSnackBarError(message: string): void {
    this.snackBar.openFromComponent(SnackBarComponent, {
      data: { type: 'error', message },
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top'
    });
  }
}



enum StatusContract {
  REGISTER = 'REGISTER', // Registrado
  SETTLEMENT = 'SETTLEMENT', // Ingresado
  CHECKOUT_OK = 'CHECKOUT_OK', // Garantía cobrada
  CHECKOUT_DECLINED = 'CHECKOUT_DECLINED', // Intento de cobro rechazado
  CHECKOUT_OK_FAIL_POR_NOTIFY = 'CHECKOUT_OK_FAIL_POR_NOTIFY' // Fallo al notificar a PoR
}
